import UserPreferenceSingleton from '../helpers/userPreferenceSingleton';
import LocalDbService, { TIME_TRACKING_NAME, UPDATE_ON_ID } from './localDbService';
import { RawTimeTrackingDataInterface } from '../mobx/interfaces/task';

interface TimeTrackingCacheServiceProps {
  organizationId: string;
  dbName?: string;
  tableName?: string;
}

interface TimeTrackingDbRow {
  id: string;
  date: string;
  createdAt: string;
  projectId: string;
  value: RawTimeTrackingDataInterface;
}

let singleton: TimeTrackingCacheService | undefined;
let organizationId: string | undefined;

export default class TimeTrackingCacheService extends LocalDbService {
  constructor(props: TimeTrackingCacheServiceProps) {
    const db_name = `${props.organizationId}`;
    props.dbName = db_name;
    props.tableName = TIME_TRACKING_NAME;
    super(props);
  }

  static getInstance() {
    const company = UserPreferenceSingleton.getInstance().getWorkspace();
    if (company) {
      if (!singleton || organizationId !== company?.id) {
        organizationId = company?.id;
        singleton = new TimeTrackingCacheService({ organizationId: company?.id });
      }
    }
    return singleton;
  }

  static removeInstance() {
    if (singleton) singleton.closeDb();
    organizationId = undefined;
    singleton = undefined;
  }

  async getTimeTrackingByWorkspace(): Promise<RawTimeTrackingDataInterface[]> {
    const rows: TimeTrackingDbRow[] = await this.getDb()
      .filter((x: TimeTrackingDbRow) => x)
      .sortBy('date');
    const result = rows?.map((x) => x.value);
    return result || [];
  }

  async setTimeTrackingData(value: RawTimeTrackingDataInterface[], companyId: string) {
    if (!value || companyId !== organizationId) return false;
    const result = await this.addBulk(value);
    return result;
  }

  async updateTimeLogList(data: RawTimeTrackingDataInterface[], archived: string[], workspace_id: string) {
    if (workspace_id !== organizationId) return false;
    await this.syncList(data, archived);
  }

  async getLastUpdatedTimeMonthWise(workspace_id?: string) {
    const result = await super.getLastUpdatedTime(`TIME_TRACKING_MONTH_WISE_${workspace_id}`);
    return result;
  }

  async setLastUpdatedTimeMonthWise(value: Record<string, string>, companyId: string) {
    if (companyId !== organizationId) return false;
    const result = await super.setLastUpdatedTime(`TIME_TRACKING_MONTH_WISE_${companyId}`, value);
    return result;
  }

  async getLastUpdatedTime(workspace_id?: string) {
    const result = await super.getLastUpdatedTime(`${UPDATE_ON_ID.TIME_TRACKING}_${workspace_id}`);
    return result;
  }

  async setLastUpdatedTime(value: string, companyId: string) {
    if (companyId !== organizationId) return false;
    const result = await super.setLastUpdatedTime(`${UPDATE_ON_ID.TIME_TRACKING}_${companyId}`, value);
    return result;
  }
}
